import {
  Box,
  LinearProgress,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { BaseScopeNode } from "./columns";

export function ScopeTableComplianceCell(
  params: GridRenderCellParams<BaseScopeNode, number | null>,
) {
  const completion = params.value;
  const findingStats = params.row.findingStats;
  const theme = useTheme();

  if (completion == null) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          No Data
        </Typography>
      </Box>
    );
  }

  const tooltipTitle = `${findingStats?.pass ?? 0} / ${findingStats?.total ?? 0} findings (${completion}%)`;

  return (
    <Tooltip title={tooltipTitle} placement="top" arrow>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LinearProgress
          variant="determinate"
          value={completion}
          sx={{
            width: "100%",
            height: 8,
            borderRadius: 1,
            backgroundColor:
              theme.palette.mode === "light" ? "#E0E0E0" : "#333333",
            "& .MuiLinearProgress-bar": {
              background: `linear-gradient(to left, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} ${completion}%)`,
              borderRadius: 0.6,
            },
          }}
        />
      </Box>
    </Tooltip>
  );
}
